import React from 'react';
import DepartmentSkillsSelector from './Editjob.js/DepartmentSkillsSelector';
import AllowedBranchesSelector from './Editjob.js/AllowedBranchesSelector'
import DatePicker from "react-multi-date-picker";


const EditJobDetails = ({
    formData,
    department,
    skillsKnown,
    onFormChange,
    allBranches = [],
    selectedBranches = [],
    onBranchesChange,
    onDepartmentChange,
    onSkillsChange,
    experienceLevels = [],
    interviewTypes = [],
    interviewModes = [],
    rounds = [],
    isReadOnly = false,
    canViewHRFields = false


}) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        onFormChange(name, value);
    };

    return (
        <div style={{ padding: '32px' }}>
            <div className="form-row" style={{ marginBottom: '10px' }}>
                <div className="form-group">
                    <label>Job Requirement ID</label>
                    <input
                        type="text"
                        name="jobReqId"
                        value={formData.jobReqId}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                    />
                </div>
                <div className="form-group">
                    <label>Created Date</label>
                    <input
                        type="text"
                        name="createdDate"
                        value={formData.createdDate}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                    />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label>Created By</label>
                    <input
                        type="text"
                        name="createdBy"
                        value={`${formData.createdBy} - ${formData.createdContact}`}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                    />
                </div>

                <div className="form-group">
                    <label>Job Requirement Status <span className="mandatory">*</span></label>
                    <select
                        name="jobReqStatus"
                        value={formData.jobReqStatus}
                        onChange={handleChange}
                        className={isReadOnly ? "readonly-field" : ""}
                        disabled={isReadOnly}

                    >
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Freeze">Freeze</option>

                    </select>
                </div>
            </div>
            {(formData.jobReqStatus === 'Closed' || formData.jobReqStatus === 'Cancelled') && (
                <div className="form-group">
                    <label>Feedback for Closure <span className="mandatory">*</span></label>
                    <textarea
                        name="feedbackForClosure"
                        value={formData.feedbackForClosure}
                        onChange={handleChange}
                        required
                        placeholder="Please provide reason for closing/cancelling this job requirement"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                        rows="3"
                    />
                </div>
            )}
            {formData.jobReqStatus === 'Closed' && (
                <div className="form-group">
                    <label>Total Selection Count <span className="mandatory">*</span></label>
                    <input
                        type="number"
                        name="totalSelectionCount"
                        value={formData.totalSelectionCount}
                        onChange={handleChange}
                        placeholder="Enter total number of students selected"
                        min="0"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
            )}
            {formData.jobReqStatus === 'Freeze' && (
                <div className="form-group">
                    <label>Feedback for Freeze <span className="mandatory">*</span></label>
                    <textarea
                        name="feedbackForFreeze"
                        value={formData.feedbackForFreeze || ""}
                        onChange={handleChange}
                        required
                        placeholder="Please provide reason for freezing this job requirement"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                        rows="3"
                    />
                </div>
            )}
            {/* Allowed Branches */}
            <AllowedBranchesSelector
                allBranches={allBranches}
                selectedBranches={selectedBranches}
                onBranchesChange={onBranchesChange}
                isReadOnly={isReadOnly}
            />
            <div className="form-row">
                <div className="form-group">
                    <label>Job Title <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="jobTitle"
                        value={formData.jobTitle}
                        onChange={handleChange}
                        placeholder="Enter job title"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>Company Name <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        placeholder="Enter company name"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
            </div>

            <div className="form-group">
                <label>Job Description <span className="mandatory">*</span></label>
                <textarea
                    name="jobDescription"
                    value={formData.jobDescription}
                    onChange={handleChange}
                    placeholder="Enter detailed job description"
                    className={isReadOnly ? "readonly-field" : ""}
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                />
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label>Job Location <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="jobLocation"
                        value={formData.jobLocation}
                        onChange={handleChange}
                        placeholder="Enter job location"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>Qualification <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="qualification"
                        value={formData.qualification}
                        onChange={handleChange}
                        placeholder="e.g., B.Tech, M.Tech, MCA"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
            </div>

            <DepartmentSkillsSelector
                department={department}
                skillsKnown={skillsKnown}
                onDepartmentChange={onDepartmentChange}
                onSkillsChange={onSkillsChange}
                departmentLabel="Department"
                skillsLabel="Skill Set Required"
                departmentRequired={true}
                skillsRequired={true}
                layout="horizontal"
                disabled={isReadOnly}
            />
            <div className="form-row">
                <div className="form-group">
                    <label>Additional Skills (Optional)</label>
                    <input
                        name="additionalSkills"
                        value={formData.additionalSkills}
                        onChange={handleChange}
                        placeholder="List out any additional skills not listed in the 'Skills Set Required' Dropdown"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                        rows="2"
                    />
                </div>
                <div className="form-group">
                    <label>Gender</label>
                    <select
                        name="gender"
                        value={formData.gender || 'All'}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    >
                        <option value="All">All</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Passed Out Year <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="passedOutYear"
                        value={formData.passedOutYear}
                        onChange={handleChange}
                        placeholder="e.g., 2024, 2023-2024"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>
                        Experience Required <span className="mandatory">*</span>
                    </label>
                    <input
                        type="text"
                        name="experienceRequired"
                        value={formData.experienceRequired}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                        placeholder="e.g. Fresher / 1-2 years / 6 months"
                    />
                </div>

            </div>

            <div className="form-row">
                <div className="form-group">
                    <label>Salary (in LPA) <span className="mandatory">*</span></label>
                    <input
                        type="text"
                        name="salary"
                        value={formData.salary}
                        onChange={handleChange}
                        placeholder="Enter salary (e.g. 3 LPA, 25,000 – 30,000, Negotiable)"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>

                <div className="form-group">
                    <label>Bond <span className="mandatory">*</span></label>
                    <select
                        name="bond"
                        value={formData.bond}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    >
                        <option value="">Select Option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>
            </div>

            {formData.bond === 'Yes' && (
                <div className="form-group">
                    <label>Bond Details <span className="mandatory">*</span></label>
                    <textarea
                        name="bondDetails"
                        value={formData.bondDetails}
                        onChange={handleChange}
                        placeholder="Enter bond details (duration, amount, terms, etc.)"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    />
                </div>
            )}

            <div className="form-row">
                <div className="form-group">
                    <label>Number of Job Openings <span className="mandatory">*</span></label>
                    <input
                        type="number"
                        name="numberOfOpenings"
                        value={formData.numberOfOpenings}
                        onChange={handleChange}
                        placeholder="Enter number of openings"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>Number of Interview Rounds <span className="mandatory">*</span></label>
                    <select
                        name="numberOfRounds"
                        value={formData.numberOfRounds}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    >
                        <option value="">Select Rounds</option>
                        {rounds.map(round => (
                            <option key={round} value={round}>{round}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label>Interview Type <span className="mandatory">*</span></label>
                    <select
                        name="interviewType"
                        value={formData.interviewType}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    >
                        <option value="">Select Interview Type</option>
                        {interviewTypes.map(type => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Mode of Interview <span className="mandatory">*</span></label>
                    <select
                        name="modeOfInterview"
                        value={formData.modeOfInterview}
                        onChange={handleChange}
                        disabled={isReadOnly}
                        className={isReadOnly ? "readonly-field" : ""}
                    >
                        <option value="">Select Mode</option>
                        {interviewModes.map(mode => (
                            <option key={mode} value={mode}>{mode}</option>
                        ))}
                    </select>
                </div>
            </div>

            {formData.interviewType === 'Direct Apply' && (
                <div className="form-group">
                    <label>Direct Apply Link <span className="mandatory">*</span></label>
                    <input
                        type="url"
                        name="directApplyLink"
                        value={formData.directApplyLink}
                        onChange={handleChange}
                        placeholder="Enter application link"
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                        style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
            )}

            {(formData.interviewType === 'Walk-in' ||
                formData.interviewType === 'Pumo Scheduled Interview') && (
                    <div className="form-row">
                        <div className="form-group">
                            <label>Interview Dates</label>

                            <DatePicker
                                multiple
                                closeOnSelect={false}
                                format="DD-MM-YYYY"
                                value={formData.interviewDate ? formData.interviewDate.split(",") : []}
                                onChange={(dates) => {
                                    const formatted = dates.map(d => d.format("DD-MM-YYYY"));
                                    onFormChange("interviewDate", formatted.join(","));
                                }}

                                disabled={isReadOnly}
                                placeholder="Select interview dates"
                                style={{
                                    width: "100%",
                                    height: "38px",
                                    borderRadius: "6px",
                                    border: "1px solid #d1d5db",
                                    padding: "0 10px",
                                    backgroundColor: isReadOnly ? "#f5f5f5" : "white",
                                    cursor: isReadOnly ? "not-allowed" : "text"
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label>Interview Location</label>
                            <input
                                type="text"
                                name="interviewLocation"
                                value={formData.interviewLocation}
                                onChange={handleChange}
                                placeholder="Enter interview location"
                                readOnly={isReadOnly}
                                disabled={isReadOnly}
                                style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                            />
                        </div>
                    </div>
                )}

            {formData.interviewType === 'Pumo Campus Drive' && (
                <div className="form-row">
                    <div className="form-group">
                        <label>Date <span className="mandatory">*</span></label>
                        <input
                            type="date"
                            name="interviewDate"
                            value={formData.interviewDate}
                            onChange={handleChange}
                            readOnly={isReadOnly}
                            disabled={isReadOnly}
                            style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                        />
                    </div>
                    <div className="form-group">
                        <label>Time <span className="mandatory">*</span></label>
                        <input
                            type="time"
                            name="interviewTime"
                            value={formData.interviewTime}
                            onChange={handleChange}
                            readOnly={isReadOnly}
                            disabled={isReadOnly}
                            style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                        />
                    </div>
                    <div className="form-group">
                        <label>Venue <span className="mandatory">*</span></label>
                        <input
                            type="text"
                            name="venue"
                            value={formData.venue}
                            onChange={handleChange}
                            placeholder="Enter venue"
                            readOnly={isReadOnly}
                            disabled={isReadOnly}
                            style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
                        />
                    </div>
                </div>
            )}

            <div className="form-group">
                <label>Additional Details</label>
                <textarea
                    name="additionalDetails"
                    value={formData.additionalDetails}
                    onChange={handleChange}
                    placeholder="Any additional information"
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    className={isReadOnly ? "readonly-field" : ""}
                />
            </div>

    {canViewHRFields && (
    <>
        <div className="form-group">
            <label>Company HR Name</label>
            <input
                type="text"
                name="companyHRName"
                value={formData.companyHRName}
                onChange={handleChange}
                placeholder="Enter HR name"
                readOnly={isReadOnly}
                disabled={isReadOnly}
                style={isReadOnly ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
            />
        </div>

        <div className="form-row">
            <div className="form-group">
                <label>Company HR Contact Number</label>
                <input
                    type="tel"
                    name="companyHRContact"
                    value={formData.companyHRContact}
                    onChange={handleChange}
                    placeholder="Enter contact number"
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                />
            </div>

            <div className="form-group">
                <label>Company HR Email ID</label>
                <input
                    type="email"
                    name="companyHREmail"
                    value={formData.companyHREmail}
                    onChange={handleChange}
                    placeholder="Enter email address"
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                />
            </div>
        </div>
    </>
)}
        </div>
    );
};

export default EditJobDetails;